// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendeFuerDieStiftungFuerKrebskrankeKinderCoburg33DE: PageEntry = {
  id: "post.spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3",
  locale: "de",
  slug: "spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3",
  seo: {
    title: "Ausbildungsstart 2019 | Dietz GmbH",
    description: "Ausbildungsstart 2019",
  },
  type: "post",
  h1: "Ausbildungsstart 2019",
  blocks: [
    { kind: "heading", level: 2, text: "Ausbildungsstart 2019" },
    { kind: "paragraph", text: "Am 02. September haben bei uns sechs junge Menschen mit dem Beginn einer Ausbildung den Grundstein für ihre berufliche Zukunft gelegt. In diesem Jahr haben wir die Ausbildungsberufe wie folgt besetzt: vier Industriemechaniker, einen Elektroniker und eine kaufmännische Auszubildende. Das finden wir spitze! Daher noch einmal: Herzlich willkommen in der Dietz-Familie – wir freuen uns auf die gemeinsame Zukunft mit euch!" },
    { kind: "paragraph", text: "Wer sich über freue Ausbildungsplätze für 2020 informieren will, darf gerne unter https://www.dietz.eu/karriere/schueler/ vorbeischauen." }
  ],
};
